module.exports = __webpack_public_path__ + "img/icon_right_arrow_purple.c1a221a3.svg";